@use "../../sass/global/global.scss" as *;

.ux-iws-nb-technical-data {
    // height transition only works in chrome and edge for now
    interpolate-size: allow-keywords;
    border-bottom: solid 2px $color-black-6;
    display: block;

    &__header {
        @media (min-width: 1440px) {
            justify-content: space-between;
            align-items: left;
            display: flex;
            flex-direction: row;
        }
    }

    &__items {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        flex-wrap: wrap;
        margin-left: 0;
        padding-top: 30px;

        @media (min-width: 1024px) {
            margin-left: 20px;
        }
        @media (min-width: 1440px) {
            margin-left: 60px;
        }
    }

    [slot="item"] {
        max-width: 50%;
        width: 220px;
        display: flex;
        flex-direction: column;
        padding: 0 15px 30px;
    }

    &__toggle-button {
        @include font(bold);
        background: none;
        border: solid 1px $color-black-1;
        cursor: pointer;
        text-align: left;
        position: relative;
        z-index: 1;
        transition: all 0.3s ease-in-out;
        color: $color-black-1;
        padding: 18px 90px 18px 30px;
        margin: 0 15px 30px;
        text-transform: uppercase;
        font-size: 13px;

        @media (min-width: 799px) {
            min-width: 320px;
        }

        @media (min-width: 1024px) {
            margin-left: 30px;
        }

        @media (min-width: 1440px) {
            border: 0;
            margin: 30px;
        }
    }

    &__toggle-button ux-icon {
        position: absolute;
        top: 50%;
        right: 30px;
        transition: transform 0.3s ease-in-out;
        transform: translateY(-50%) rotate(0deg);
        margin-left: 10px;
        font-size: 24px;

        @media (prefers-reduced-motion: reduce) {
            transition: none;
        }
    }

    &__toggle-button::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        transition: width 0.3s ease-in-out;
        background-color: $color-blue-headline;

        @media (min-width: 1440px) {
            width: 1px;
        }
    }

    &__toggle-button:hover,
    &__toggle-button:focus-visible {
        color: #fff;

        &::before {
            width: 100%;
        }
    }

    &[opened] &__toggle-button {
        ux-icon {
            transform: translateY(-50%) rotate(45deg);
        }
    }

    &__content-container {
        overflow: hidden;
        height: 0;
        transition: all 0.3s ease-in-out;
    }

    &[opened] &__content-container {
        height: auto;
    }

    &__content {
        padding: 30px 15px;
        border-top: solid 1px $color-black-6;

        @media (min-width: 799px) {
            padding: 50px 30px;
        }

        @media (min-width: 1024px) {
            padding: 60px 30px;
        }
    }

    .ux-iws-nb-technical-data-download-button {
        margin-top: 20px;
    }
}
